import { useState } from 'react';
import useToken from '../../../hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

/**
 * Hook personalizado para gestionar licencias de una orden
 */
const useLicenciasGestion = (
    GuardarComentario,
    ObtenerDetallesOrden,
    idOrden,
    orden,
    onComentarioAgregado
) => {
    const { token, setToken, nombreCompleto, idUsuario } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();
    const [seguroStateEliminar, setseguroStateEliminar] = useState({ isOpen: false, idLicencia: null, idOrdenDetalle: null });
    const [modalStateAgregarLicencia, setModalStateAgregarLicencia] = useState({ isOpen: false, isLoading: true, idOrdenDetalle: null });
    const [licenciasModal, setLicenciasModal] = useState([]);
    const [selectedLicencia, setSelectedLicencia] = useState(null);

    const [modalStateAsignarRenovacion, setModalStateAsignarRenovacion] = useState({ isOpen: false, isLoading: true, idOrdenDetalle: null, vCodigoBarras: null });
    const [licenciasRenovacionModal, setLicenciasRenovacionModal] = useState([]);
    const [selectedLicenciaRenovacion, setSelectedLicenciaRenovacion] = useState(null);
    const [tipoRenovacion, setTipoRenovacion] = useState(null);

    /**
     * Obtiene licencias disponibles para asignar a un producto
     */
    const obtenerLicenciasParaModal = async (vCodigoBarras, idOrdenDetalle, idClienteAkasia) => {
        console.log(vCodigoBarras);

        setModalStateAgregarLicencia({ isOpen: true, isLoading: true, idOrdenDetalle: idOrdenDetalle });
        setLicenciasModal([]);

        const response = await fetch(
            `/api/orden/act_obtenerLicenciasParaModal/?vCodigoBarras=${vCodigoBarras}&idClienteAkasia=${idClienteAkasia}`,
            {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }
        ).catch((error) => {
            
            showErrorToast('' + error.message);
            console.log('Hubo un problema con la peticion Fetch:' + error.message);
            return;
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {
                var jsonObjLicencias = JSON.parse(data.detalles);
                console.log(jsonObjLicencias);
                setLicenciasModal(jsonObjLicencias);
            }

            setModalStateAgregarLicencia({ isOpen: true, isLoading: false, idOrdenDetalle: idOrdenDetalle });
        } else {
            setModalStateAgregarLicencia({ isOpen: true, isLoading: false, idOrdenDetalle: idOrdenDetalle });
            
            showErrorToast(response.status + ' ' + response.statusText);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };

    /**
     * Cancela (elimina) la asignación de una licencia a la orden
     */
    const cancelarLicenciaOrden = async (idLicencia, idOrdenDetalle) => {
        var objNuevaOrden = {};
        objNuevaOrden.idLicencia = idLicencia;
        objNuevaOrden.idOrdenDetalle = idOrdenDetalle;
        objNuevaOrden.idUsuario = idUsuario;

        var jsonLicenciaOrdenDetalle = JSON.stringify(objNuevaOrden);

        const response = await fetch("/api/orden/act_EliminarLicenciaOrdenDetalle/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
            body: jsonLicenciaOrdenDetalle,
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {
                GuardarComentario(
                    idOrden,
                    `<b>${nombreCompleto}</b> desvinculó la licencia: <b><a href='/licencias/detalle/${idLicencia}' target='_blank' class='stretched-link text-info position-relative'>#${idLicencia}</a></b>`,
                    2,
                    orden,
                    (comentarioBD) => {
                        if (onComentarioAgregado) {
                            onComentarioAgregado(comentarioBD);
                        }
                    }
                );
                ObtenerDetallesOrden();
                setseguroStateEliminar({ isOpen: false, idLicencia: null, idOrdenDetalle: null });
                showSuccessToast(data.vMessage);
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
     * Guarda la asignación de una licencia a la orden
     */
    const guardarLicenciaOrdenDetalle = async (idLicencia, idOrdenDetalle) => {
        var objNuevaOrden = {};
        objNuevaOrden.idLicencia = idLicencia;
        objNuevaOrden.idOrdenDetalle = idOrdenDetalle;
        objNuevaOrden.idUsuario = idUsuario;

        var jsonLicenciaOrdenDetalle = JSON.stringify(objNuevaOrden);

        const response = await fetch("/api/orden/act_GuardarNuevaOrdenDetalle/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
            body: jsonLicenciaOrdenDetalle + "",
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {
                GuardarComentario(
                    idOrden,
                    `<b>${nombreCompleto}</b> vinculó la licencia: <b><a href='/licencias/detalle/${idLicencia}' target='_blank' class='stretched-link text-info position-relative'>#${idLicencia}</a></b> al producto en la orden detalle #${idOrdenDetalle}`,
                    2,
                    orden,
                    (comentarioBD) => {
                        if (onComentarioAgregado) {
                            onComentarioAgregado(comentarioBD);
                        }
                    }
                );
                ObtenerDetallesOrden();
                setModalStateAgregarLicencia(prev => ({ ...prev, isOpen: false, idOrdenDetalle: null }));
                showSuccessToast(data.vMessage);
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
     * Obtiene licencias disponibles para asignar módulos
     */
    const obtenerLicenciasParaModulo = async (idProducto, idOrdenDetalle, idClienteAkasia, vCodigoBarras, bIsRenovacion) => {
        console.log("Obteniendo licencias para renovación:", idProducto);

        setModalStateAsignarRenovacion({
            isOpen: true,
            isLoading: true,
            idOrdenDetalle: idOrdenDetalle,
            vCodigoBarras: vCodigoBarras
        });

        setLicenciasRenovacionModal([]);

        const response = await fetch(
            `/api/orden/obtenerLicenciasActivasParaRenovacion/?idProducto=${idProducto}&idClienteAkasia=${idClienteAkasia}&idOrdenDetalle=${idOrdenDetalle}`,
            {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }
        ).catch((error) => {
            
            showErrorToast('Error al obtener licencias: ' + error.message);
            setModalStateAsignarRenovacion(prev => ({ ...prev, isLoading: false }));
            return;
        });

        if (response.ok) {
            const data = await response.json();
            if (data.iResponseType == 1) {
                const licencias = JSON.parse(data.detalles);
                setLicenciasRenovacionModal(licencias.licencias || []);

                if (bIsRenovacion) {
                    setTipoRenovacion(licencias.tipoRenovacion);
                }
            }
            setModalStateAsignarRenovacion(prev => ({ ...prev, isLoading: false }));
        } else {
            setModalStateAsignarRenovacion(prev => ({ ...prev, isLoading: false }));
            
            showErrorToast('Error al obtener licencias para renovación');
        }
    };

    /**
     * Guarda la asignación de renovación o módulo
     */
    const guardarAsignacionRenovacion = async (idLicencia, idOrdenDetalle) => {
        const objAsignacionRenovacion = {
            idLicencia: idLicencia,
            idOrdenDetalle: idOrdenDetalle,
            idUsuario: idUsuario,
            vTipoRenovacion: tipoRenovacion,
            vCodigoBarras: modalStateAsignarRenovacion.vCodigoBarras
        };

        const response = await fetch("/api/orden/asignarLicenciaModulo/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(objAsignacionRenovacion)
        }).catch((error) => {
            showErrorToast('Error al asignar renovación: ' + error);
            console.log('Error:', error);
        });

        if (response.ok) {
            const data = await response.json();
            if (data.iResponseType == 1) {
                GuardarComentario(
                    idOrden,
                    `<b>${nombreCompleto}</b> asignó la licencia <b><a href='/licencias/detalle/${idLicencia}' target='_blank' class='stretched-link text-info position-relative'>#${idLicencia}</a></b> para producto (${modalStateAsignarRenovacion.vCodigoBarras})`,
                    2,
                    orden,
                    (comentarioBD) => {
                        if (onComentarioAgregado) {
                            onComentarioAgregado(comentarioBD);
                        }
                    }
                );
                ObtenerDetallesOrden();
                setModalStateAsignarRenovacion({ isOpen: false, isLoading: true, idOrdenDetalle: null, vCodigoBarras: null });
                showSuccessToast("Licencia asignada a módulo exitosamente");
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    return {
        // Estados
        seguroStateEliminar,
        setseguroStateEliminar,
        modalStateAgregarLicencia,
        setModalStateAgregarLicencia,
        licenciasModal,
        selectedLicencia,
        setSelectedLicencia,
        modalStateAsignarRenovacion,
        setModalStateAsignarRenovacion,
        licenciasRenovacionModal,
        selectedLicenciaRenovacion,
        setSelectedLicenciaRenovacion,
        tipoRenovacion,

        // Funciones
        obtenerLicenciasParaModal,
        cancelarLicenciaOrden,
        guardarLicenciaOrdenDetalle,
        obtenerLicenciasParaModulo,
        guardarAsignacionRenovacion
    };
};

export default useLicenciasGestion;
